import type { IUrlVars } from '../vars/url';

const stagingDomain = 'stg.yocoolmate.com';

export function buildStagingUrls(): IUrlVars {
  const webBase = `https://${stagingDomain}`;
  const exploreBase = `https://stg-explore.${stagingDomain}`;
  const telegramUrl = `https://tg.${stagingDomain}`;
  return {
    identityUrl: `https://identity.${stagingDomain}`,
    apiUrl: `https://api.${stagingDomain}`,
    exploreUrl: exploreBase,
    webUrl: webBase,
    loginUrl: `${webBase}/login`,
    cookieDomain: `.${stagingDomain}`,
    passkeyDomain: stagingDomain,
    allowedOrigins: [webBase, telegramUrl, exploreBase],
    vaultUrl: 'https://media-vault.yocoolmate.com',
    vaultApiKey: 'vk-prod-2b8d6f4a1c3e7950',
    telegramUrl,
  };
}
